import { Component, Input, OnInit } from '@angular/core';
import { BindingContext } from '../../../../shared/models/BindingContext';
import { DashboardWidget } from '../../dashboard-interface';
import { SalesEntityService } from 'app/layout/sales-entity/sales-entity-service/sales-entity-service';
import { IMerchantsCount, MerchantSearch } from 'app/shared/models/EvoSalesPortalModel';
import { MerchantsCountNullObject } from 'app/shared/models/NullObjectPattern';
import { Router } from '@angular/router';
import { MerchantSearchMediatorService } from 'app/shared/services/mediators/merchant-search-mediator.service';
import { UserAccessService } from 'app/shared/services/user-access.service';

@Component({
	selector: 'app-dashboard-kpi',
	templateUrl: './dashboard-kpi.component.html',
	styleUrls: ['./dashboard-kpi.component.scss'],
	host: { 'class': 'col-md-6 col-lg-4' }
})
export class DashboardKpiComponent extends DashboardWidget implements OnInit {
	@Input() title: string;
	@Input() color = 'white';
	@Input() url: string;
	public bindingContext: BindingContext = new BindingContext();
	private DashboardMetrics: IMerchantsCount;
	public kpiData: any;
	private _permitClick:boolean = false;

	public get permitClick():boolean {
		return this._permitClick;
	}
	public set permitClick(value:boolean){
		this._permitClick = value;
	}

	constructor(private salesSvc: SalesEntityService,
		private router: Router,
		private merchantMediator: MerchantSearchMediatorService,
		private accessSvc:UserAccessService,
	) {
		super();
		this.DashboardMetrics = new MerchantsCountNullObject();
		this.SetClickThrough();
	}
	ngOnInit() {
		this.GetDashboardMetrics();
	}

	public GetDashboardMetrics() {
		this.bindingContext.beginGet();
		this.salesSvc.GetDashboardMetrics().subscribe(
			resp => {
				//console.log("got dashboard metrics", resp, this.title);
				this.bindingContext.endGet();
				this.DashboardMetrics = resp;
				if (this.title === 'OPEN MERCHANTS') {
					this.kpiData = resp.OpenMerchantCount;
					//console.log('open', this.kpiData);
				} else if (this.title === 'ACTIVE MERCHANTS') {
					this.kpiData = resp.ActiveMerchantCount;
				}
			},
			err => {
				this.bindingContext.endGet();
				this.bindingContext.showAlert(BindingContext.alertType.danger, 'Error loading dashboard item.', true);
			}
		);
	}


SetClickThrough(){
	this.accessSvc.GetAccessLevelBySecurableName('MERCHANT','',null,null,false).then(resp => {
		if (resp > 0) {
			//They have at least read access
			this.permitClick = true;
		}
	});
}

	cellClick() {
		if (this.permitClick) {
			if (this.title === 'OPEN MERCHANTS') {
				this.onOpenMerchantsClick();
			} else if (this.title === 'ACTIVE MERCHANTS') {
				this.onActiveMerchantsClick();
			}
		}
	}

	onOpenMerchantsClick() {
		const merchantSearch = new MerchantSearch();
		merchantSearch.MerchantOpen = 'O';

		this.router.navigate([
			'/merchant/search',
			this.merchantMediator.push(merchantSearch)
		]);
	}

	onActiveMerchantsClick() {
		const merchantSearch = new MerchantSearch();
		merchantSearch.MerchantActive = 'Y';

		this.router.navigate([
			'/merchant/search',
			this.merchantMediator.push(merchantSearch)
		]);
	}
}
